import { L } from '@lang';
import { ReactComponent as LogoIcon } from '../../shared/assets/icon-vkd-logo-72.svg';
import { InstallPage, Placeholder, Button } from '../../shared/ui';
import { useAppContext } from '../../core';
import { createVkDatingMaLink } from './model';
import styles from './PwaInstallUnavailableOnOldIos.module.css';

export function PwaInstallUnavailableOnOldIos() {
  const { domainZone } = useAppContext();

  return (
    <InstallPage className={styles.root}>
      <Placeholder
        icon={<LogoIcon />}
        title={L.t('pwa_disabled_old_ios_placeholder_title')}
        action={
          <Button href={createVkDatingMaLink(domainZone)} rel="noopener noreferrer" stretched>
            {L.t('pwa_disabled_old_ios_placeholder_action')}
          </Button>
        }
        stretched
      >
        {L.t('pwa_disabled_old_ios_placeholder_subtitle')}
      </Placeholder>
    </InstallPage>
  );
}
